/* rf-fit.js — Will-It-Fit space checker behavior (P3-7; SD-11R 2026-08-05).
   Drives sections/rf-fit-checker.liquid ([data-rf-fit] root).
   FACTS rule: every machine dimension is Liquid-rendered into data attributes
   (metafield-first: product metafields win, block settings are fallbacks —
   see the section header) — this file only COMPARES them against the
   shopper's own numbers. Pure comparison, no fudge factors: no live PDP
   states a clearance, so none exists here. "Exact fit" fires only at zero
   spare. in ↔ cm is exact ×2.54 (display rounding only); comparisons run in
   thousandths of an inch (precision hygiene).
   SD-11R empty state: until BOTH width and depth are entered the result
   card collapses to ONE line; the height hint renders only after width/depth
   are in (and only when the machine publishes a height the shopper hasn't
   given one to check against). */
(function () {
  'use strict';

  var CM_PER_IN = 2.54; /* exact by definition */

  /* thousandths of an inch — integer compare, no FP noise */
  function k(vIn) {
    return Math.round(vIn * 1000);
  }

  /* 3-decimal display trim — in↔cm at ×2.54 terminates at exactly 3 dp for
     1-dp inch inputs (22.8 in = 57.912 cm), so 3 dp is EXACT, not rounded
     (QA-2: 1-dp display destroyed true exact fits across the toggle, and a
     sub-0.05 spare printed as a bare "−0") */
  function trim(n) {
    var s = n.toFixed(3);
    return s.replace(/0+$/, '').replace(/\.$/, '');
  }

  function init(root) {
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-rf-panel]'));
    var verdictEl = root.querySelector('[data-rf-verdict]');
    var inputs = {
      w: root.querySelector('[data-rf-in="w"]'),
      d: root.querySelector('[data-rf-in="d"]'),
      h: root.querySelector('[data-rf-in="h"]')
    };
    if (!verdictEl || !panels.length) return;

    var queued = false;

    function unit() {
      var u = root.querySelector('[data-rf-fit-unit]:checked');
      return u ? u.value : 'in';
    }

    function selectedPanel() {
      var m = root.querySelector('[data-rf-machine]:checked');
      var idx = m ? parseInt(m.getAttribute('data-idx'), 10) : 0;
      for (var i = 0; i < panels.length; i++) {
        if (parseInt(panels[i].getAttribute('data-idx'), 10) === idx) return panels[i];
      }
      return panels[0];
    }

    /* user input value in INCHES, or null */
    function userIn(key) {
      var el = inputs[key];
      if (!el) return null;
      var v = parseFloat(el.value);
      if (isNaN(v) || v <= 0) return null;
      return unit() === 'cm' ? v / CM_PER_IN : v;
    }

    /* display a length (stored in inches) in the active unit */
    function fmtLen(vIn) {
      if (unit() === 'cm') return trim(vIn * CM_PER_IN) + ' cm';
      return trim(vIn) + ' in';
    }

    function fmtSpare(spareIn) {
      var v = unit() === 'cm' ? spareIn * CM_PER_IN : spareIn;
      var body = trim(Math.abs(v)) + (unit() === 'cm' ? ' cm' : ' in');
      if (k(spareIn) === 0) return 'exact';
      return (spareIn > 0 ? '+' : '−') + body;
    }

    /* re-render every PDP-verbatim dim span in the active unit */
    function updateDimSpans() {
      var spans = root.querySelectorAll('[data-rf-dim]');
      for (var i = 0; i < spans.length; i++) {
        var vIn = parseFloat(spans[i].getAttribute('data-in'));
        if (!isNaN(vIn)) spans[i].textContent = fmtLen(vIn);
      }
    }

    function dim(panel, name) {
      var raw = panel.getAttribute(name);
      if (raw === null || raw === '') return null;
      var v = parseFloat(raw);
      return isNaN(v) ? null : v;
    }

    function el(tag, cls, text) {
      var node = document.createElement(tag);
      if (cls) node.className = cls;
      if (text) node.textContent = text;
      return node;
    }

    function row(list, axis, machIn, yourIn) {
      var li = el('li', 'rf-fit-v__row');
      li.appendChild(el('span', 'rf-fit-v__axis', axis));
      li.appendChild(el('span', 'rf-fit-v__nums', 'machine ' + fmtLen(machIn) + ' · yours ' + fmtLen(yourIn)));
      var spareIn = yourIn - machIn;
      var cls = 'rf-fit-v__spare ';
      if (k(spareIn) > 0) cls += 'rf-fit-v__spare--ok';
      else if (k(spareIn) === 0) cls += 'rf-fit-v__spare--zero';
      else cls += 'rf-fit-v__spare--no';
      li.appendChild(el('span', cls, fmtSpare(spareIn)));
      list.appendChild(li);
      return k(spareIn);
    }

    /* one verdict card for a dimension group ("In use" / "Folded for storage") */
    function groupCard(name, title, mach, user) {
      var spares = [];
      var metas = [];
      var rows = el('ul', 'rf-fit-v__rows');
      var rotated = false;

      /* groupCard is only reached once BOTH width and depth are entered
         (SD-11R: the empty state collapses to one line in render()) */
      if (mach.w !== null && mach.d !== null) {
        var fitsNormal = k(user.w - mach.w) >= 0 && k(user.d - mach.d) >= 0;
        var fitsRot = k(user.w - mach.d) >= 0 && k(user.d - mach.w) >= 0;
        if (!fitsNormal && fitsRot) rotated = true;
        var mw = rotated ? mach.d : mach.w;
        var md = rotated ? mach.w : mach.d;
        spares.push(row(rows, 'Width', mw, user.w));
        spares.push(row(rows, 'Depth', md, user.d));
        if (rotated) metas.push('Fits turned 90° — the machine’s longer side runs along your depth.');
      } else if (mach.w !== null || mach.d !== null) {
        /* only one floor axis published — compare it against the shopper's
           longer side (pure comparison, orientation is theirs to choose) */
        var only = mach.w !== null ? mach.w : mach.d;
        var longest = Math.max(user.w || 0, user.d || 0);
        spares.push(row(rows, 'Longest side', only, longest));
        metas.push('Only one floor dimension is published on the product page.');
      }

      if (mach.h !== null) {
        if (user.h !== null) {
          spares.push(row(rows, 'Height', mach.h, user.h));
        }
        /* no per-card height nag: the single height hint under the result
           (render()) covers it — SD-11R */
      } else if (mach.w !== null || mach.d !== null) {
        metas.push('Height isn’t published on the product page.');
      }

      var state = 'info';
      var pill = 'Enter your space above';
      if (spares.length) {
        var worst = Math.min.apply(null, spares);
        if (worst < 0) {
          state = 'no';
          pill = '✕ Won’t fit';
        } else if (worst === 0) {
          state = 'exact';
          pill = 'Exact fit — zero to spare';
        } else {
          state = 'ok';
          pill = '✓ Fits';
        }
      }

      var card = el('div', 'rf-fit-v rf-fit-v--' + state);
      var top = el('div', 'rf-fit-v__top');
      top.appendChild(el('p', 'rf-fit-v__title', title + ' · ' + name));
      top.appendChild(el('span', 'rf-fit-v__pill', pill));
      card.appendChild(top);
      if (rows.children.length) card.appendChild(rows);
      for (var i = 0; i < metas.length; i++) {
        card.appendChild(el('p', 'rf-fit-v__meta', metas[i]));
      }
      return card;
    }

    function render() {
      if (!root.isConnected) return;
      updateDimSpans();

      var panel = selectedPanel();
      for (var i = 0; i < panels.length; i++) {
        panels[i].hidden = panels[i] !== panel;
      }

      var name = panel.getAttribute('data-name') || 'This machine';
      var user = { w: userIn('w'), d: userIn('d'), h: userIn('h') };
      var use = { w: dim(panel, 'data-use-w'), d: dim(panel, 'data-use-d'), h: dim(panel, 'data-use-h') };
      var fold = { w: dim(panel, 'data-fold-w'), d: dim(panel, 'data-fold-d'), h: dim(panel, 'data-fold-h') };

      verdictEl.textContent = '';
      /* No-dims machines get NO verdict card: the server-rendered spec panel
         above already carries the honest "not published — here's what it does
         say" state, and duplicating it here rendered TWO cards saying the same
         thing (Blake-spotted bug, fixed 2026-07-09). One card per machine per
         state: honest state = the panel; comparable state = these verdicts. */
      var anyUse = use.w !== null || use.d !== null || use.h !== null;
      var anyFold = fold.w !== null || fold.d !== null || fold.h !== null;
      if (!anyUse && !anyFold) return;

      /* SD-11R: until BOTH width and depth are in, the result collapses to
         one line — no pill, no rows, no height talk */
      if (user.w === null || user.d === null) {
        var solo = el('div', 'rf-fit-v rf-fit-v--info');
        solo.appendChild(el('p', 'rf-fit-v__solo', 'Enter your width and depth above and we’ll check the fit.'));
        verdictEl.appendChild(solo);
        return;
      }

      /* a height-only group with no shopper height has nothing to compare —
         skip the card (the height hint below covers it) */
      function comparable(mach) {
        return mach.w !== null || mach.d !== null || (mach.h !== null && user.h !== null);
      }
      if (anyUse && comparable(use)) verdictEl.appendChild(groupCard(name, 'In use', use, user));
      if (anyFold && comparable(fold)) verdictEl.appendChild(groupCard(name, 'Folded for storage', fold, user));

      /* SD-11R: height guidance appears ONLY after width/depth are filled,
         as a small hint under the result */
      if (user.h === null && (use.h !== null || fold.h !== null)) {
        verdictEl.appendChild(el('p', 'rf-fit-v__hint', 'Add a height to check under-bed or shelf clearance.'));
      }
    }

    /* rAF-coalesced re-render (LAW: rAF + isConnected for interactive UI) */
    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        render();
      });
    }

    /* unit toggle converts what's typed so the measurement is preserved —
       exact ×2.54 at 3 dp (terminating for 1-dp inputs: 22.8 in ↔ 57.912 cm
       round-trips byte-exact, so a true exact fit SURVIVES the toggle — QA-2);
       the verdict always compares
       what's visible in the fields (WYSIWYG) */
    var lastUnit = unit();
    function convertInputs() {
      var u = unit();
      if (u === lastUnit) return;
      ['w', 'd', 'h'].forEach(function (key) {
        var elIn = inputs[key];
        if (!elIn || elIn.value === '') return;
        var v = parseFloat(elIn.value);
        if (isNaN(v)) return;
        var out = u === 'cm' ? v * CM_PER_IN : v / CM_PER_IN;
        elIn.value = String(Math.round(out * 1000) / 1000);
      });
      lastUnit = u;
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.matches) return;
      if (t.matches('[data-rf-fit-unit]')) {
        convertInputs();
        schedule();
      } else if (t.matches('[data-rf-machine]')) {
        schedule();
      }
    });
    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t.matches && t.matches('[data-rf-in]')) schedule();
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-rf-fit]').forEach(init);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
